"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSpuAndOrderItem = void 0;
const react_1 = require("react");
const trade_1 = require("@tencent/tccp-frontend-contract/trade");
const order_1 = require("../modules/order");
function useSpuAndOrderItem() {
    const buildParamList = (0, react_1.useCallback)((spuTreeNode) => trade_1.ClientParamList.fromSpuTree(spuTreeNode), []);
    const buildFlatValues = (0, react_1.useCallback)((spuTreeNode, orderItem) => {
        const paramList = trade_1.ClientParamList.fromSpuTree(spuTreeNode);
        const flatValues = (0, order_1.fromOrderItemToValues)(orderItem, paramList);
        return flatValues;
    }, []);
    /** 啥都要呗 */
    const buildAll = (0, react_1.useCallback)((spuTreeNode, orderItem) => {
        const paramList = trade_1.ClientParamList.fromSpuTree(spuTreeNode);
        const flatValues = (0, order_1.fromOrderItemToValues)(orderItem, paramList);
        return {
            paramList,
            flatValues,
        };
    }, []);
    return { buildParamList, buildFlatValues, buildAll };
}
exports.useSpuAndOrderItem = useSpuAndOrderItem;
